// src/pages/SuperAdminDashboard.js
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import DashboardShell from '../components/dashboard/DashboardShell';
import StatTile from '../components/dashboard/departmentadmin/StatTile';
import UsersByRoleList from '../components/dashboard/superadmin/UsersByRoleList';
import MasterAdminDashboardView from '../components/dashboard/masteradmin/MasterAdminDashboardView';
import { getUser } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function SuperAdminDashboard() {
  const user = getUser();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/stat/get_super_admin_dashboard_stats.php`, {
          withCredentials: true
        });
        if (isMounted) setStats(response.data);
      } catch (error) {
        console.error('Error fetching super admin dashboard stats:', error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchStats();
    return () => { isMounted = false; };
  }, []);

  return (
    <DashboardShell title={`Welcome, ${user.name}`} subtitle="System-wide oversight">
      <Row className="g-3 mb-1">
        <Col md={3}>
          <StatTile title="Companies" icon="bi-building" value={stats?.totalCompanies ?? 0} loading={loading} />
        </Col>
        <Col md={3}>
          <StatTile title="Departments" icon="bi-diagram-3" value={stats?.totalDepartments ?? 0} loading={loading} />
        </Col>
        <Col md={3}>
          <StatTile title="Upcoming Trainings" icon="bi-calendar-event" value={stats?.upcomingTrainingsCount ?? 0} loading={loading} />
        </Col>
        <Col md={3}>
          <StatTile title="Completed Trainings" icon="bi-check-circle" value={stats?.completedTrainingsCount ?? 0} loading={loading} />
        </Col>
      </Row>
      <Row className="g-3 mt-1">
        <Col md={4}>
          <StatTile title="Certificates Issued" icon="bi-award" value={stats?.totalCertificates ?? 0} loading={loading} />
        </Col>
        <Col md={8}>
          <UsersByRoleList data={stats?.usersByRole ?? []} loading={loading} />
        </Col>
      </Row>
      <hr className="my-4" />
      <h5 className="mb-3">Organization-Wide Training Overview</h5>
      <MasterAdminDashboardView />
    </DashboardShell>
  );
}

export default SuperAdminDashboard;
